(ns com.theplantscape.plant-web.draw.formatting)

(defn plant-common-name [plant]
(or (first (:en (:plant/common-name plant)))
          (first (:en (:common-name plant)))
          (:plant/scientific-name plant)
          (:scientific-name plant)))

(defn plant-name [fmt plant]
  (if (= :common fmt)
    (if (or (map? (:plant/common-name plant)) (map? (:common-name plant)))
      (or (first (:en (:plant/common-name plant)))
          (first (:en (:common-name plant)))
          (:plant/scientific-name plant)
          (:scientific-name plant))
      (or (:plant/common-name plant) (:common-name plant)))
    (or (:plant/scientific-name plant) (:scientific-name plant))))
